import PropTypes from "prop-types";
import * as React from "react";
import { Button, DeleteIcon } from "../../themeV2";
import FilePicker from "./FilePicker";
import ImageSection from "./ImageSection";
import css from "./ShopImagesEditor.module.css";

const BannerSection = React.forwardRef(function BannerSection(
  { banner, onFiles, onRemove },
  headingRef,
) {
  return (
    <ImageSection
      id="banner"
      ref={headingRef}
      title="Banner"
      description="JPEG, PNG or WebP, up to 10 MB. Shown across the top of the shop page."
      actions={
        <>
          <FilePicker inputLabel="Replace banner" onFiles={onFiles}>
            {banner ? "Replace" : "Upload"}
          </FilePicker>
          {banner && (
            <Button variant="text" leading={<DeleteIcon />} onClick={onRemove}>
              Remove banner
            </Button>
          )}
        </>
      }
    >
      {banner && (
        <img
          className={css.bannerPreview}
          src={banner.url}
          alt=""
          width={960}
          height={240}
        />
      )}
    </ImageSection>
  );
});

BannerSection.propTypes = {
  banner: PropTypes.shape({ url: PropTypes.string.isRequired }),
  onFiles: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default BannerSection;
